// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YSb6","left":"styles_left__3liWV","desktopActions":"styles_desktopActions__2a_Hx","title":"styles_title__1BTln"};